import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row, Card, CardBody } from 'reactstrap';

import { Input, Toggle } from '@/components/form';
import ResourceForm from '@/components/resources/form';
import View from '@/components/view';
import translator from '@/services/translator';

const Form = ({ match }) => (
  <View>
    <ResourceForm resource="Language" id={match.params.id} onSuccess={(item) => translator.refreshLanguage(item)}>
      {({ submitting, renderActions }) => (
        <>
          <Card>
            <CardBody className={submitting ? 'loading' : ''}>
              <Row>
                <Col lg={6}>
                  <Input name="name" />
                </Col>
                <Col lg={6}>
                  <Input name="locale" />
                </Col>
                <Col lg={4}>
                  <Toggle name="enabled" />
                </Col>
              </Row>
            </CardBody>
          </Card>
          <div className="mt-4 mb-4">{renderActions()}</div>
        </>
      )}
    </ResourceForm>
  </View>
);

Form.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
  }).isRequired
};

export default Form;
